import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { isAllowedAdminRole, logoutAdmin } from "store/slices/authSlice";

interface AdminProtectedRouteProps {
  children: React.ReactElement;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { admin, isAuthenticated, token } = useAppSelector((state) => state.auth);
  const hasAllowedRole = isAllowedAdminRole(admin?.role);
  const sessionToken = sessionStorage.getItem("admin_token");

  useEffect(() => {
    if (
      (isAuthenticated && token && !hasAllowedRole) ||
      (isAuthenticated && token && !sessionToken)
    ) {
      dispatch(logoutAdmin());
    }
  }, [dispatch, hasAllowedRole, isAuthenticated, sessionToken, token]);

  if (!isAuthenticated || !token || !sessionToken) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!hasAllowedRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
